interface techType {
  [k: string]: Array<{ name: string; link: string; description?: string }>;
  preferred: Array<{ name: string; link: string; description?: string }>;
  learning: Array<{ name: string; link: string; description?: string }>;
}

export const data: Array<{
  name: string;
  description: string;
  data: techType;
}> = [
  {
    name: "Languages",
    description:
      "In my web development work, I specialize in building applications using TypeScript and React. During my MSc dissertation, I worked with Python and a variety of machine learning libraries to develop and test models.",
    data: {
      preferred: [
        {
          name: "TypeScript",
          link: "https://img.icons8.com/color/452/typescript.png",
          description:
            "Have been using it for 6+ years for type-safe web development in React projects.",
        },
        {
          name: "JavaScript",
          link: "https://d2gdtie5ivbdow.cloudfront.net/media/images/javascript.png",
          description: "For dynamic web development and scripting tasks.",
        },
        {
          name: "Python",
          link: "https://img.icons8.com/color/452/python.png",
          description:
            "Used for scripting, data science and machine learning as part of my MSc dissertation.",
        },
      ],
      learning: [
        {
          name: "Java",
          link: "https://img.icons8.com/color/452/java-coffee-cup-logo.png",
          description:
            "First language I learnt to code in during university, briefly used it for automation testing in 2018.",
        },
        {
          name: "MongoDB",
          link: "https://1000logos.net/wp-content/uploads/2020/08/MongoDB-Emblem.jpg",
          description:
            "Learning it for building flexible, document-based databases.",
        },
        {
          name: "SQL",
          link: "https://cdn2.iconfinder.com/data/icons/programming-50/64/206_programming-sql-data-database-512.png",
          description:
            "Practicing queries and relational data modeling mainly for testing purposes.",
        },
        {
          name: "Q#",
          link: "https://qph.cf2.quoracdn.net/main-thumb-ti-2001545-200-rogbkbvvrwtndohttfoyxkxejvympjor.jpeg",
          description: "Experimenting with quantum computing algorithms.",
        },
      ],
    },
  },
  {
    name: "Libraries",
    description:
      "I work mainly with React, Redux or XState for state management, RxJS to handle data streams. I have experience building grids with AG Grid and data visualisations with D3. For automation testing, I currently use Playwright.",
    data: {
      preferred: [
        {
          name: "React",
          link: "https://img.icons8.com/color/452/react-native.png",
          description:
            "Building interactive and scalable frontend applications.",
        },
        {
          name: "Redux",
          link: "https://cdn.iconscout.com/icon/free/png-256/redux-283024.png",
          description: "Managing complex application state across components.",
        },
        {
          name: "Ag-Grid",
          link: "https://pbs.twimg.com/profile_images/1362741614909804546/CGoO_TV__400x400.png",
          description:
            "Displaying and interacting with financial data in web interfaces.",
        },
        {
          name: "Jest",
          link: "https://icon.icepanel.io/Technology/svg/Jest.svg",
          description: "Testing frontend TypeScript and React code reliably.",
        },
        {
          name: "Playwright",
          link: "https://playwright.dev/img/playwright-logo.svg",
          description:
            "End-to-end testing of web applications and workflow validation.",
        },
        {
          name: "Node",
          link: "https://www.the-guild.dev/blog-assets/nodejs-esm/nodejs_logo.png",
          description: "Building backend services and APIs with JavaScript.",
        },
      ],
      learning: [
        {
          name: "Flask",
          link: "https://icon.icepanel.io/Technology/png-shadow-512/Flask.png",
          description: "Experimenting with lightweight Python backends.",
        },
        {
          name: "D3.js",
          link: "https://raw.githubusercontent.com/d3/d3-logo/master/d3.png",
          description: "Creating dynamic and interactive data visualizations.",
        },
        {
          name: "Three.js",
          link: "https://canada1.discourse-cdn.com/flex035/uploads/threejs/optimized/2X/e/e4f86d2200d2d35c30f7b1494e96b9595ebc2751_2_992x1000.png",
          description:
            "Rendering 3D scenes in web applications for visuals and demos.",
        },
        {
          name: "RxJS",
          link: "https://images.seeklogo.com/logo-png/43/2/rxjs-logo-png_seeklogo-437295.png",
          description: "Handling async data streams and events in frontends.",
        },
        {
          name: "XState",
          link: "https://d2eip9sf3oo6c2.cloudfront.net/tags/images/000/001/282/square_480/xstate.png",
          description:
            "Managing complex component and workflow states in high frequency financial applications.",
        },
        {
          name: "Cypress",
          link: "https://images.icon-icons.com/3911/PNG/512/cypress_logo_icon_247239.png",
          description: "Automating frontend testing and workflow validation.",
        },
      ],
    },
  },
  {
    name: "Styling",
    description:
      "For styling React applications, I mainly use styled-components to create reusable components. I also have experience working with Material UI, Bootstrap, and Sass in previous projects.",
    data: {
      preferred: [
        {
          name: "Material UI",
          link: "https://v4.mui.com/static/logo.png",
          description: "Creating consistent, responsive UI components quickly.",
        },
        {
          name: "styled-components",
          link: "https://miro.medium.com/max/480/1*Iohnw2aOQ5EBghVoqKA7VA.png",
          description: "Writing scoped CSS directly in React components.",
        },
        {
          name: "Bootstrap",
          link: "https://img.icons8.com/color/452/bootstrap.png",
          description: "Rapidly prototyping responsive layouts and styles.",
        },
      ],
      learning: [
        {
          name: "Semantic UI",
          link: "https://cdn.worldvectorlogo.com/logos/semantic-ui.svg",
          description: "Exploring alternative UI component library.",
        },
        {
          name: "SASS",
          link: "https://1000logos.net/wp-content/uploads/2020/08/Sass-Logo.png",
          description:
            "Writing modular and maintainable CSS with variables and mixins.",
        },
      ],
    },
  },
  {
    name: "Machine Learning",
    description:
      "For my MSc dissertation, I used Python and libraries such as TensorFlow and pandas to build and evaluate models. My research focused on a comparative analysis of hybrid supervised learning models and LSTM neural networks.",
    data: {
      preferred: [
        {
          name: "Python",
          link: "https://img.icons8.com/color/452/python.png",
          description:
            "Built time series, ML models and LST NNs as part of my dissertation on equity price prediction.",
        },
        {
          name: "Numpy",
          link: "https://user-images.githubusercontent.com/50221806/86498201-a8bd8680-bd39-11ea-9d08-66b610a8dc01.png",
          description: "Performing numerical computations efficiently.",
        },
        {
          name: "Pandas",
          link: "https://pandas.pydata.org/static/img/pandas_mark.svg",
          description: "Manipulating and analyzing structured data.",
        },
      ],
      learning: [
        {
          name: "TensorFlow",
          link: "https://user-images.githubusercontent.com/13250741/64669187-33b55380-d47e-11e9-8bbf-c02a9d42f9a7.png",
          description:
            "Experimenting with neural networks and deep learning as part of my dissertation and online courses.",
        },
        {
          name: "PyTorch",
          link: "https://upload.wikimedia.org/wikipedia/commons/1/10/PyTorch_logo_icon.svg",
          description: "Building and training Machine Learning models.",
        },
        {
          name: "R",
          link: "https://www.r-project.org/logo/Rlogo.svg",
          description: "Exploring statistical analysis and data visualization.",
        },
      ],
    },
  },
  {
    name: "DevOps",
    description:
      "I'm a certified AWS Cloud Practitioner and have experience deploying React applications on AWS. I have also worked with Google Cloud Platform (GCP) in previous projects to manage cloud infrastructure.",
    data: {
      preferred: [
        {
          name: "GitHub",
          link: "https://img.icons8.com/fluent/452/github.png",
          description: "Managing source code, pull requests, and repos.",
        },
        {
          name: "Bitbucket",
          link: "https://cdn.worldvectorlogo.com/logos/bitbucket-icon.svg",
          description: "Managing source code, pull requests, and repos.",
        },
        {
          name: "VSCode",
          link: "https://freebsdfoundation.org/wp-content/uploads/2024/05/vscode-logo.png",
          description:
            "The best code editor in the universe, don’t even think about disagreeing!",
        },
        {
          name: "AWS",
          link: "https://img.icons8.com/color/452/amazon-web-services.png",
          description:
            "Deploying and managing cloud infrastructure. Certified Cloud Practitioner 2022.",
        },
        {
          name: "Jenkins",
          link: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Jenkins_logo.svg/1920px-Jenkins_logo.svg.png",
          description: "Automating CI/CD pipelines and deployments.",
        },
      ],
      learning: [
        {
          name: "GCP",
          link: "https://img.icons8.com/color/452/google-cloud.png",
          description: "Exploring cloud services and deployments.",
        },
        {
          name: "Splunk",
          link: "https://cf-assets.www.cloudflare.com/slt3lc6tev37/5b8uSBmNjgeYVVpZP411Uz/771a30d33c12bda5485e6809ccfd6c6d/Splunk_logo_high_res.png",
          description:
            "Monitoring logs and analyzing user data for debugging production issues.",
        },
        {
          name: "TeamCity",
          link: "https://cdn.worldvectorlogo.com/logos/teamcity-icon.svg",
          description: "CI/CD automation workflows.",
        },
        {
          name: "Vite",
          link: "https://v2.vitejs.dev/logo.svg",
          description: "Building fast frontend dev environments.",
        },
        {
          name: "Nx",
          link: "https://nx.dev/docs/_astro/Nx-dark.Cvgk1ru3.svg",
          description: "Structuring monorepos and sharing code efficiently.",
        },
      ],
    },
  },
  {
    name: "UX/UI",
    description:
      "In my frontend development work, I frequently collaborate with designers and use Figma as my primary tool for creating and refining user interface designs.",
    data: {
      preferred: [
        {
          name: "Figma",
          link: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
          description:
            "Designing UI mockups and prototypes for fun and for work projects.",
        },
        {
          name: "AdobeXD",
          link: "https://www.logo.wine/a/logo/Adobe_Illustrator/Adobe_Illustrator-Logo.wine.svg",
          description: "Creating interactive design prototypes.",
        },
      ],
      learning: [
        {
          name: "Adobe PhotoShop",
          link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRVNSz_1KXXo7jIJqQgI3GdHsLbzVqyMgzNtPoA011pZBkh-EqjnFijejw40rA4rX5HNdk&usqp=CAU",
          description: "Improving image editing skills for UI assets.",
        },
        {
          name: "Adobe Illustrator",
          link: "https://www.logo.wine/a/logo/Adobe_Illustrator/Adobe_Illustrator-Logo.wine.svg",
          description: "Creating vector graphics for icons and designs.",
        },
      ],
    },
  },
];

export const techStackMenu = {
  name: "techstack",
  url: "/techstack",
  subMenu: [
    {
      subName: "Languages",
      url: "/language",
      items: {
        preferred: ["TypeScript", "JavaScript", "Python"],
        learning: ["Java", "MongoDB", "SQL", "Q#"],
      },
    },
    {
      subName: "Libraries",
      url: "/libraries",
      items: {
        preferred: ["React", "Redux", "Jest", "Cypress"],
        learning: ["Ag-Grid", "Node", "Flask", "D3.js", "Three.js"],
      },
    },
    {
      subName: "Styling",
      url: "/styling",
      items: {
        preferred: ["Material UI", "styled-components", "Bootstrap"],
        learning: ["Semantic UI", "SASS"],
      },
    },
    {
      subName: "Machine Learning",
      url: "/machinelearning",
      items: {
        preferred: ["Python", "Numpy", "Pandas"],
        learning: ["TensorFlow", "PyTorch", "R"],
      },
    },
    {
      subName: "DevOps",
      url: "devops",
      items: {
        preferred: ["GitHub", "Bitbucket", "VSCode"],
        learning: ["GCP", "AWS", "Jenkins", "TeamCity", "Vite", "Nx"],
      },
    },
    {
      subName: "UX/UI",
      url: "uxui",
      items: {
        preferred: ["Figma", "AdobeXd"],
        learning: ["Adobe PhotoShop", "Adobe Illustrator"],
      },
    },
  ],
};

export const menuItems: any = [
  {
    name: "Experience",
    url: "experience",
    subMenu: [
      "JP Morgan Chase & Co.",
      "Capco",
      "Cancer Research UK",
      "CENTURY Tech",
    ],
  },
  {
    name: "Education",
    url: "education",
    subMenu: ["Msc Applied Statistics", "BSc Mathematics & Physics"],
  },
  // {
  //   name: "Creative",
  //   url: "creative",
  //   subMenu: ["Mineral Database"],
  // },
  {
    name: "Certifications",
    url: "certifications",
    subMenu: [
      "Qiskit Global Summer School 2022",
      "IBM Machine Learning",
      "Machine Learning with TensorFlow",
      "Deep Reinforcement Learning",
    ],
  },
];

export const iconMenuItems: any = [
  {
    name: "Portfolio",
    url: "portfolio",
  },
  {
    name: "Tech Stack",
    url: "techstack",
  },
  {
    name: "Experience",
    url: "experience",
  },
  {
    name: "Education",
    url: "education",
  },
  {
    name: "Certifications",
    url: "certifications",
  },
  {
    name: "Projects",
    url: "projects",
  },
];

export const techList: Array<{ name: string; link: string }> = [
  {
    name: "TypeScript",
    link: "https://img.icons8.com/color/452/typescript.png",
  },
  {
    name: "JavaScript",
    link: "https://d2gdtie5ivbdow.cloudfront.net/media/images/javascript.png",
  },

  { name: "Python", link: "https://img.icons8.com/color/452/python.png" },

  {
    name: "Java",
    link: "https://img.icons8.com/color/452/java-coffee-cup-logo.png",
  },
  {
    name: "MongoDB",
    link: "https://1000logos.net/wp-content/uploads/2020/08/MongoDB-Emblem.jpg",
  },
  {
    name: "SQL",
    link: "https://cdn2.iconfinder.com/data/icons/programming-50/64/206_programming-sql-data-database-512.png",
  },
  {
    name: "Q#",
    link: "https://qph.cf2.quoracdn.net/main-thumb-ti-2001545-200-rogbkbvvrwtndohttfoyxkxejvympjor.jpeg",
  },

  {
    name: "React",
    link: "https://img.icons8.com/color/452/react-native.png",
  },
  {
    name: "Redux",
    link: "https://cdn.iconscout.com/icon/free/png-256/redux-283024.png",
  },
  {
    name: "Ag-Grid",
    link: "https://pbs.twimg.com/profile_images/1362741614909804546/CGoO_TV__400x400.png",
  },
  {
    name: "Jest",
    link: "https://icon.icepanel.io/Technology/svg/Jest.svg",
  },
  {
    name: "Cypress",
    link: "https://images.icon-icons.com/3911/PNG/512/cypress_logo_icon_247239.png",
  },
  {
    name: "Node",
    link: "https://www.the-guild.dev/blog-assets/nodejs-esm/nodejs_logo.png",
  },

  {
    name: "Flask",
    link: "https://static-00.iconduck.com/assets.00/programming-language-flask-icon-2048x1826-wf5k5ugs.png",
  },
  {
    name: "D3.js",
    link: "https://raw.githubusercontent.com/d3/d3-logo/master/d3.png",
  },
  {
    name: "Three.js",
    link: "https://global.discourse-cdn.com/standard17/uploads/threejs/original/2X/e/e4f86d2200d2d35c30f7b1494e96b9595ebc2751.png",
  },
  {
    name: "RxJS",
    link: "https://images.seeklogo.com/logo-png/43/2/rxjs-logo-png_seeklogo-437295.png",
  },
  {
    name: "XState",
    link: "https://d2eip9sf3oo6c2.cloudfront.net/tags/images/000/001/282/square_480/xstate.png",
  },
  {
    name: "Playwright",
    link: "https://playwright.dev/img/playwright-logo.svg",
  },
  {
    name: "Material UI",
    link: "https://v4.mui.com/static/logo.png",
  },
  {
    name: "styled-components",
    link: "https://miro.medium.com/max/480/1*Iohnw2aOQ5EBghVoqKA7VA.png",
  },
  {
    name: "Bootstrap",
    link: "https://img.icons8.com/color/452/bootstrap.png",
  },
  {
    name: "Semantic UI",
    link: "https://cdn.worldvectorlogo.com/logos/semantic-ui.svg",
  },
  {
    name: "SASS",
    link: "https://1000logos.net/wp-content/uploads/2020/08/Sass-Logo.png",
  },
  {
    name: "Python",
    link: "https://img.icons8.com/color/452/python.png",
  },
  {
    name: "Numpy",
    link: "https://user-images.githubusercontent.com/50221806/86498201-a8bd8680-bd39-11ea-9d08-66b610a8dc01.png",
  },
  {
    name: "Pandas",
    link: "https://pandas.pydata.org/static/img/pandas_mark.svg",
  },
  {
    name: "TensorFlow",
    link: "https://user-images.githubusercontent.com/13250741/64669187-33b55380-d47e-11e9-8bbf-c02a9d42f9a7.png",
  },
  {
    name: "PyTorch",
    link: "https://commons.wikimedia.org/wiki/File:PyTorch_logo_icon.svg",
  },
  {
    name: "R",
    link: "https://www.r-project.org/logo/Rlogo.svg",
  },

  {
    name: "GitHub",
    link: "https://img.icons8.com/fluent/452/github.png",
  },
  {
    name: "Bitbucket",
    link: "https://cdn.worldvectorlogo.com/logos/bitbucket-icon.svg",
  },
  {
    name: "VSCode",
    link: "https://freebsdfoundation.org/wp-content/uploads/2024/05/vscode-logo.png",
  },
  {
    name: "AWS",
    link: "https://img.icons8.com/color/452/amazon-web-services.png",
  },
  {
    name: "Jenkins",
    link: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Jenkins_logo.svg/1920px-Jenkins_logo.svg.png",
  },
  {
    name: "GCP",
    link: "https://img.icons8.com/color/452/google-cloud.png",
  },
  {
    name: "Splunk",
    link: "https://cf-assets.www.cloudflare.com/slt3lc6tev37/5b8uSBmNjgeYVVpZP411Uz/771a30d33c12bda5485e6809ccfd6c6d/Splunk_logo_high_res.png",
  },
  {
    name: "TeamCity",
    link: "https://cdn.worldvectorlogo.com/logos/teamcity-icon.svg",
  },
  {
    name: "Vite",
    link: "https://v2.vitejs.dev/logo.svg",
  },
  {
    name: "Nx",
    link: "https://nx.dev/docs/_astro/Nx-dark.Cvgk1ru3.svg",
  },
  {
    name: "Figma",
    link: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
  },
  {
    name: "AdobeXD",
    link: "https://cdn.iconscout.com/icon/free/png-512/adobe-xd-1869035-1583159.png",
  },
  {
    name: "Adobe PhotoShop",
    link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRVNSz_1KXXo7jIJqQgI3GdHsLbzVqyMgzNtPoA011pZBkh-EqjnFijejw40rA4rX5HNdk&usqp=CAU",
  },
  {
    name: "Adobe Illustrator",
    link: "https://www.logo.wine/a/logo/Adobe_Illustrator/Adobe_Illustrator-Logo.wine.svg",
  },
];

export const categoryContent: Array<{
  categoryName: string;
  description: string;
  projects: Array<{ title: string; url: string }>;
}> = [
  {
    categoryName: "Languages",
    description:
      "In my web development work, I specialize in building applications using TypeScript and React. During my MSc dissertation, I worked with Python and a variety of machine learning libraries to develop and test models.",
    projects: [
      {
        title: "JP Morgan Markets",
        url: "https://markets.jpmorgan.com/pricing-and-execution/execute",
      },
      { title: "Bestinvest", url: "https://www.bestinvest.co.uk/" },
      {
        title: "Bankline Natwest",
        url: "https://www.natwest.com/business/ways-to-bank/bankline.html",
      },
      { title: "Cancer Research UK", url: "https://www.cancerresearchuk.org/" },
    ],
  },
  {
    categoryName: "Libraries",
    description:
      "I work mainly with React, Redux or XState for state management, RxJS to handle data streams. I have experience building grids with AG Grid and data visualisations with D3. For automation testing, I currently use Playwright.",
    projects: [
      {
        title: "JP Morgan Markets",
        url: "https://markets.jpmorgan.com/pricing-and-execution/execute",
      },
      { title: "Bestinvest", url: "https://www.bestinvest.co.uk/" },
      {
        title: "Bankline Natwest",
        url: "https://www.natwest.com/business/ways-to-bank/bankline.html",
      },
      { title: "Cancer Research UK", url: "https://www.cancerresearchuk.org/" },
    ],
  },
  {
    categoryName: "UX/UI",
    description:
      "In my frontend development work, I frequently collaborate with designers and use Figma as my primary tool for creating and refining user interface designs.",
    projects: [
      {
        title: "JP Morgan Markets",
        url: "https://markets.jpmorgan.com/pricing-and-execution/execute",
      },
      { title: "Bestinvest", url: "https://www.bestinvest.co.uk/" },
      {
        title: "Bankline Natwest",
        url: "https://www.natwest.com/business/ways-to-bank/bankline.html",
      },
      { title: "Cancer Research UK", url: "https://www.cancerresearchuk.org/" },
    ],
  },
  {
    categoryName: "DevOps",
    description:
      "I'm a certified AWS Cloud Practitioner and have experience deploying React applications on AWS. I have also worked with Google Cloud Platform (GCP) in previous projects to manage cloud infrastructure.",
    projects: [
      {
        title: "JP Morgan Markets",
        url: "https://markets.jpmorgan.com/pricing-and-execution/execute",
      },
      { title: "Bestinvest", url: "https://www.bestinvest.co.uk/" },
      {
        title: "Bankline Natwest",
        url: "https://www.natwest.com/business/ways-to-bank/bankline.html",
      },
      { title: "Cancer Research UK", url: "https://www.cancerresearchuk.org/" },
    ],
  },
  {
    categoryName: "Machine Learning",
    description:
      "For my MSc dissertation, I used Python and libraries such as TensorFlow and pandas to build and evaluate models. My research focused on a comparative analysis of hybrid supervised learning models and LSTM neural networks.",
    projects: [
      {
        title: "Coming Soon",
        url: "",
      },
    ],
  },
  {
    categoryName: "Styling",
    description:
      "For styling React applications, I mainly use styled-components to create reusable components. I also have experience working with Material UI, Bootstrap, and Sass in previous projects.",
    projects: [
      {
        title: "JP Morgan Markets",
        url: "https://markets.jpmorgan.com/pricing-and-execution/execute",
      },
      { title: "Bestinvest", url: "https://www.bestinvest.co.uk/" },
      {
        title: "Bankline Natwest",
        url: "https://www.natwest.com/business/ways-to-bank/bankline.html",
      },
      { title: "Cancer Research UK", url: "https://www.cancerresearchuk.org/" },
    ],
  },
];
